import { ReportFramed } from './ReportFramed';
export default ReportFramed;
